import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import { InfoCard, useSidebarPinState } from '@backstage/core-components';
import {
  UserSettingsProfileCard,
  UserSettingsIdentityCard,
  UserSettingsLanguageToggle,
  UserSettingsPinToggle,
} from '@backstage/plugin-user-settings';

// Same layout as the built-in UserSettingsGeneral, minus UserSettingsThemeToggle
// — light is the app's only theme (see ./index.tsx), so there's no Dark/Auto
// choice to offer.
function AppearanceCard() {
  const { isMobile } = useSidebarPinState();
  return (
    <InfoCard title="Appearance" variant="gridItem">
      <List dense>
        <UserSettingsLanguageToggle />
        {!isMobile && <UserSettingsPinToggle />}
      </List>
    </InfoCard>
  );
}

export function GeneralSettings() {
  return (
    <Grid container direction="row" spacing={3}>
      <Grid item xs={12} md={6}>
        <UserSettingsProfileCard />
      </Grid>
      <Grid item xs={12} md={6}>
        <AppearanceCard />
      </Grid>
      <Grid item xs={12} md={6}>
        <UserSettingsIdentityCard />
      </Grid>
    </Grid>
  );
}
